import "prismjs";
import "./prism-javascript";
import "prismjs/components/prism-qml";
